module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-package"
  }, [(!_vm.hideTitle) ? _c('div', {
    staticClass: "package-title"
  }, [_vm._v(_vm._s(_vm.itemType))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "package-details",
    class: {
      noBorder: _vm.noBorder
    }
  }, [_c('div', {
    staticClass: "_summary dflex justify-space-between mb-3",
    class: {
      altMeta: _vm.altMeta
    }
  }, [_c('div', {
    staticClass: "package-subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.item.title) + " " + _vm._s(_vm.subtitleAppend) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "package-pricing mt-2"
  }, [_c('span', {
    staticClass: "currency"
  }, [_vm._v("$")]), _vm._v(" "), _c('span', {
    staticClass: "cost"
  }, [_vm._v(_vm._s(_vm.itemPrice) + "/month")])])]), _vm._v(" "), _c('div', {
    staticClass: "payment-note dflex"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("schedule")]), _vm._v(" "), _c('div', {
    staticClass: "__note"
  }, [_vm._v("\n        Your card will be charged each month starting on\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("formatSlashedDate")(_vm.currentDate)))])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a716274","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentCard/packageDetails.vue
// module id = 1734
// module chunks = 180